"use strict";import{defineElement as e}from"@spectrum-web-components/base/src/define-element.js";import{Card as a}from"./src/Card.js";e("sp-card",a);
//# sourceMappingURL=sp-card.js.map
